import { useCallback } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { useSalesEditor } from '@/modules/sales-editor/hooks/use-sales-editor.ts'
import type { SalesEditorTemplate } from '@/modules/sales-editor/state/types.ts'

import type { DialogProps } from '../types'

interface Props extends DialogProps {
  template: SalesEditorTemplate
}

export const DeleteSalesTemplateDialog = ({
  isOpen,
  onClose,
  template,
}: Props) => {
  const { removeTemplate } = useSalesEditor()
  const onSubmit = useCallback(() => {
    removeTemplate(template.id)
    onClose()
  }, [onClose, removeTemplate, template])

  return (
    <Dialog
      bigDialog
      childrenClassName="space-y-6"
      panelClassName="lg:max-w-[533px]"
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Delete template</Dialog.Title>
      </Dialog.Header>

      <p className="text-sm">
        Are you sure you want to delete this template? This cannot be undone.
      </p>

      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          variant="destructive"
          onClick={onSubmit}
        >
          Delete
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
